/**
 * Returns the deepest focused element by walking through shadow roots.
 *
 * Standard `document.activeElement` stops at the shadow host boundary.
 * This utility traverses nested shadow roots to find the true focused
 * element — e.g. inmar-hc-modal's X button or a slotted input.
 *
 * @returns The deepest active element, or null if nothing is focused.
 */
export function deepActiveElement(): HTMLElement | null {
  let el = document.activeElement as HTMLElement | null;
  while (el?.shadowRoot?.activeElement) {
    el = el.shadowRoot.activeElement as HTMLElement;
  }
  return el;
}
